<mc-switch-board color="secondary-vivid">
  <mc-switch-board-bar class="mc-spring-board">
    <ng-container *ngIf="checklist$ | async as checklist">
      <div class="mc-spring-board-header">
        <mc-project-checklist-avatar [disabled]="true" [checklist]="checklist.Id | mcProjectChecklistAsync | async"></mc-project-checklist-avatar>
      </div>

      <div class="mc-spring-board-body">
        <ul class="mc-property-list">
          <li class="mc-property-list-item-truncate" *ngIf="checklist.CreatedByLicenseUserId | mcLicenseUserAsync | async as licenseUser">
            <span class="mc-property-name">Owner: </span>
            <span class="mc-property-value mc-truncate" [matTooltip]="licenseUser?.User?.FullName">
              {{ licenseUser?.User?.FullName }}
            </span>
          </li>
          <li>
            <span class="mc-property-name">Checklist Type: </span>
            <span class="mc-property-value">
              {{checklist.Type === ProjectChecklistType.GenericList ? 'Generic List' : 'Project Files'}}
            </span>
          </li>
          <li *ngIf="checklist?.Analytics?.CompletedPercent">
            <span class="mc-property-name">Total Complete: </span>
            <span class="mc-property-value">
              {{checklist.Analytics.CompletedPercent | number : '1.0-1'}}%
            </span>
          </li>
          <li class="mc-property-list-item-truncate">
            <span class="mc-property-name">Project: </span>
            <mc-project-avatar class="mc-property-value" [project]="project$ | async" [showAvatar]="false" [truncate]="true"></mc-project-avatar>
          </li>
          <ng-container *ngIf="checklist.Type === ProjectChecklistType.ProjectFiles">
            <li class="mc-property-list-item-truncate">
              <span class="mc-property-name">Branch: </span>
              <mc-branch-avatar class="mc-property-value" [branchName]="checklist.BranchName" [project]="project$ | async" [showAvatar]="false" [truncate]="true" (navigate)="navigate.emit()"></mc-branch-avatar>
            </li>
          </ng-container>
        </ul>
      </div>

      <mat-nav-list class="mc-spring-board-footer mc-list-text-size-normal mc-list-text-weight-normal mc-list-bg-dark mc-list-compact">
        <a href="#" *ngIf="showOverviewTab$ | async" mat-list-item [mcProfileTab]="ProjectChecklistProfileTab.Overview" [(mcProfileTabSelected)]="profileTab">
          <mat-icon matListItemIcon fontSet="project-titan" fontIcon="icon-overview" color="primary"></mat-icon> Overview
        </a>
        <a href="#" *ngIf="showSettingsTab$ | async" mat-list-item [mcProfileTab]="ProjectChecklistProfileTab.Settings" [(mcProfileTabSelected)]="profileTab">
          <mat-icon matListItemIcon fontSet="project-titan" fontIcon="icon-gear" color="primary"></mat-icon> Settings
        </a>
        <a href="#" *ngIf="showColumnsTab$ | async" mat-list-item [mcProfileTab]="ProjectChecklistProfileTab.Columns" [(mcProfileTabSelected)]="profileTab">
          <mat-icon matListItemIcon fontSet="project-titan" fontIcon="icon-columns" color="primary"></mat-icon> Columns
        </a>
        <a href="#" *ngIf="showRowsTab$ | async" mat-list-item [mcProfileTab]="ProjectChecklistProfileTab.Rows" [(mcProfileTabSelected)]="profileTab">
          <mat-icon matListItemIcon fontSet="project-titan" fontIcon="icon-rows" color="primary"></mat-icon> Rows
        </a>
        <a href="#" *ngIf="showActivityTab$ | async" mat-list-item [mcProfileTab]="ProjectChecklistProfileTab.Activity" [(mcProfileTabSelected)]="profileTab">
          <mat-icon matListItemIcon fontSet="project-titan" fontIcon="icon-clock" color="primary"></mat-icon> Activity
        </a>
        <a *ngIf="showSaveAsTemplate$ | async" mat-list-item mcPreventDefault="click" (click)="onSaveAsTemplate()">
          <mat-icon matListItemIcon fontSet="project-titan" fontIcon="icon-download" color="primary"></mat-icon> Save as Template
        </a>
        <a *ngIf="showDeleteTab$ | async" mat-list-item [mcProfileTab]="ProjectChecklistProfileTab.Delete" [(mcProfileTabSelected)]="profileTab">
          <mat-icon matListItemIcon fontSet="project-titan" fontIcon="icon-trash" color="primary"></mat-icon> Delete
        </a>
      </mat-nav-list>
    </ng-container>
  </mc-switch-board-bar>

  <mc-switch-board-content [ngSwitch]="profileTab" class="mc-spring-board">
    <mat-tab-group mat-stretch-tabs="false" class="mc-spring-board-body mc-arrow-tabs mc-arrow-tabs-border" color="secondary-invert" *ngSwitchCase="ProjectChecklistProfileTab.Overview">
      <mat-tab label="Overview">
        <ng-container *ngIf="checklist$ | async as checklist">
          <mc-project-checklist-overview *ngIf="checklist.Analytics; else noChecklistData" [checklist]="checklist"></mc-project-checklist-overview>
          <ng-template #noChecklistData>
            <mc-no-item-placeholder size="NoItemPlaceholderSize.Normal" message="This checklist has no data."></mc-no-item-placeholder>
          </ng-template>
        </ng-container>
      </mat-tab>
    </mat-tab-group>

    <mat-tab-group mat-stretch-tabs="false" class="mc-spring-board-body mc-arrow-tabs mc-arrow-tabs-border" color="secondary-invert" *ngSwitchCase="ProjectChecklistProfileTab.Settings">
      <mat-tab label="Settings">
        <mc-project-checklist-settings-form #checklistSettingsForm [checklist]="checklist$ | async" mode="edit-checklist" [projectId]="(checklist$ | async)?.ProjectId" (saved)="onSaveClicked($event)" (cancel)="onCancelClicked()"></mc-project-checklist-settings-form>
      </mat-tab>
    </mat-tab-group>

    <mat-tab-group mat-stretch-tabs="false" class="mc-spring-board-body mc-arrow-tabs mc-arrow-tabs-border" color="secondary-invert" *ngSwitchCase="ProjectChecklistProfileTab.Columns">
      <mat-tab label="Columns">
        <mc-project-checklist-columns-form #checklistColumnsForm [checklist]="checklist$ | async" (saved)="onSaveClicked($event)" (cancel)="onCancelClicked()"></mc-project-checklist-columns-form>
      </mat-tab>
    </mat-tab-group>

    <mat-tab-group mat-stretch-tabs="false" class="mc-spring-board-body mc-arrow-tabs mc-arrow-tabs-border" color="secondary-invert" *ngSwitchCase="ProjectChecklistProfileTab.Rows">
      <mat-tab label="Rows">
        <mc-project-checklist-rows-form *ngIf="checklist$ | async as checklist" #checklistRowsForm [ngClass]="{ 'mc-switch-board-body-slim': checklist.Type === ProjectChecklistType.ProjectFiles }" [branchName]="checklist.BranchName" [checklist]="checklist" [projectId]="checklist.ProjectId" (saved)="onSaveClicked($event)" (cancel)="onCancelClicked()"></mc-project-checklist-rows-form>
      </mat-tab>
    </mat-tab-group>

    <mat-tab-group mat-stretch-tabs="false" class="mc-spring-board-body mc-arrow-tabs mc-arrow-tabs-border" color="secondary-invert" *ngSwitchCase="ProjectChecklistProfileTab.Activity">
      <mat-tab label="Activity">
        <mc-project-checklist-notification-list [checklistId]="(checklist$ | async)?.Id"></mc-project-checklist-notification-list>
      </mat-tab>
    </mat-tab-group>

    <mat-tab-group mat-stretch-tabs="false" class="mc-spring-board-body mc-arrow-tabs mc-arrow-tabs-border" color="secondary-invert" *ngSwitchCase="ProjectChecklistProfileTab.Delete">
      <mat-tab label="Delete">
        <mc-project-checklist-deletion-form [checklist]="checklist$ | async" (deleted)="onChecklistDeleted()" (cancel)="onCancelClicked()"></mc-project-checklist-deletion-form>
      </mat-tab>
    </mat-tab-group>
  </mc-switch-board-content>
</mc-switch-board>